"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var getBettingOptions_1 = __importDefault(require("./getBettingOptions"));
var getSportTypeBySportTags_1 = __importDefault(require("./getSportTypeBySportTags"));
function getSportTypeBySelectedSports(sports) {
    var _a = getBettingOptions_1.default(), sportIds = _a.sportIds, selectedSportIds = _a.selectedSportIds;
    if (sportIds.length === selectedSportIds.length) {
        return constants_1.SportType.Mix;
    }
    return getSportTypeBySportTags_1.default(sports, selectedSportIds);
}
exports.default = getSportTypeBySelectedSports;
//# sourceMappingURL=getSportTypeBySelectedSports.js.map